import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ONE_WAY_IN_HIGHLIGHTED_SERVICES } from 'src/constants/hook-keys';
import { OneWayInServicesService } from 'src/api/v2';

const useHighlightedServices = (clusterId: string) => {
  const [oneWayInServicesService] = useState(new OneWayInServicesService());

  const highlightedServicesQuery = useQuery({
    queryKey: [ONE_WAY_IN_HIGHLIGHTED_SERVICES],
    queryFn: () => oneWayInServicesService.getHighlightedServices(clusterId),
    retry: false,
    enabled: !!clusterId,
    refetchOnMount: true,
  });

  const highlightedServices = highlightedServicesQuery.data;

  return { highlightedServices, highlightedServicesLoading: highlightedServicesQuery.isLoading };
};

export default useHighlightedServices;
